import { Component, OnInit, Inject, HostListener } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {LangChange} from "../../../../../lang-change";
import {TranslateService} from '@ngx-translate/core';
import {Language} from "../../../../../common/models/language";
import {Utils} from "../../../../../common/services/Utils";
import {CollegeInfoService} from "../../../services/college-info.service";
import {Enroll} from "../../../../../common/models/enroll";
import {CommonService} from "../../../../shared/services/common.service";
import {EnrollApplicationService} from "../../../services/enroll-application.service";
import {CenterProfession} from '../../../../user/components/dictionary/profession/center-profession';
import {AuthService} from '../../../../../common/services/auth.service';
import {CenterSpecialization} from '../../../../../common/dtos/center-specialization';
import {CenterSpecializationService} from '../../../../shared/services/center-specialization.service';
import {PaymentFormService} from '../../../../../common_services/payment-form.service';
import {DictionaryService} from '../../../../shared/services/dictionary.service';

@Component({
  selector: 'app-enroll-application-dialog',
  templateUrl: './enroll-application-dialog.component.html',
  styleUrls: ['./enroll-application-dialog.component.scss']
})
export class EnrollApplicationDialogComponent extends LangChange implements OnInit {

  application = new Enroll(0, null, null);
  currLanguage = '';
  colleges: College[];
  educated: any[];
  regionProfessions: CenterProfession[];
  specializations: CenterSpecialization[];
  captchaData = {captchaId: null, captchaCode: null, data: null};
  // captchaData = null;
  confirmPassword = "";
  acceptTermsConditions = true;
  studylanguages = [];
  paymentForms: any[] = [];
  grantTypeList: any[] = [];
  departments: any[];

  constructor(public dialogRef: MatDialogRef<EnrollApplicationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private translateService: TranslateService,
              public _utils: Utils,
              private collegeInfoService: CollegeInfoService,
              private _commonService: CommonService,
              private _authService: AuthService,
              private _enrollApplicationService: EnrollApplicationService) {
    super(translateService);
  }

  ngOnInit() {
    this.currLanguage = Language.getLangObject(this.translateService.currentLang).name;
    this.application.lang = (this.currLanguage === 'kz' ? 2 : 1);
    this.reloadCaptcha();
    this.loadPaymentForms();
    this.initDicEducatedList();
    this.initStudyLanguages();
    this.loadDepartments();
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
    this.currLanguage = Language.getLangObject(this.translateService.currentLang).name;
    this.application.lang = (this.currLanguage === 'kz' ? 2 : 1);
  }

  close(): void {
    this.dialogRef.close();
  }

  getColleges() {
    if (this.application.professionid == 0 || this.application.specializationid == 0 || !this.application.paymentformid)  { return; }
    this._utils.blockStart();
    this.collegeInfoService.getCollegesWithGrant(this.application.professionid, this.application.specializationid, this.application.educatedid,
      this.application.studylanguageid, this.translateService.currentLang, this.application.paymentformid).subscribe(
      response => {
        this.colleges = response['colleges'];
        this._utils.blockStop();
      },
      error => console.log(error)
    );
  }

  reloadCaptcha() {
    this._commonService.getCaptcha().subscribe(data => {
      this.captchaData.captchaId = data['captchaId'];
      this.captchaData.data = data['data'];
    });
  }

  onSubmit(): void {
    this._utils.blockStart();
    const formData: FormData = new FormData();
    this.application.login = this.application.email;
    formData.append('applicationDTO', JSON.stringify(this.application));
    this._enrollApplicationService.sendRegistrationApplication(formData, this.captchaData).subscribe(
      response => {
        this._utils.blockStop();
        if (response.status === 'ERROR') {
          this.notifyInputError(response);
          return;
        }
        if (response.status === 'SUCCESS') {
          this._utils.notifySuccess(this._translateService.instant('enrolls_register.sent'), null);
          this.close();
          this._authService.loginEnroll(this.application);
        }
      },
      error => {
        console.error(error);
        this._utils.blockStop();
        this._utils.notifyError(this._translateService.instant('error_occurred'), null);
        return;
      }
    );
  }

  notifyInputError(response: any): void {
    const errorList = response.additional;
    for (let i = 0; i < errorList.length; i++) {
      this._utils.notifyError(this._translateService.instant(errorList[i]), null);
    }
    if (response.data) {
      if (response.data.passwordInputError === true) {
        this._utils.notifyError(this._translateService.instant('password_length_err'), null);
      }
      if (response.data.emailInputError === true) {
        this._utils.notifyError(this._translateService.instant('email_input_error'), null);
      }
      if (response.data.emailDuplicateError === true) {
        this._utils.notifyError(this._translateService.instant('email_duplicate_error'), null);
      }
      if (response.data.applicationEmailDuplicateError === true) {
        this._utils.notifyError(this._translateService.instant('application_email_duplicate_error'), null);
      }
      if (response.data.captchaCodeError === true) {
        this._utils.notifyError('Не верно введен код', null);
      }
    }
  }

  initRegionProfessions() {
    if (!this.application.studylanguageid || !this.application.educatedid || !this.application.paymentformid)  { return; }
    this._utils.blockStart();
    const filter = {
      studyLanguageId : this.application.studylanguageid,
      hasCount: true,
      educatedId: this.application.educatedid
    };
    // бесплатное обучение
    if (this.application.paymentformid == 2) {
      this._enrollApplicationService.getCenterProfessions(filter).subscribe(data => {
        this.regionProfessions = data;
        Language.updateListLocalizedName(this.regionProfessions);
        this._utils.blockStop();
      });
      // платное обучение
    } else if (this.application.paymentformid == 1) {
      this._enrollApplicationService.getCenterProfessionsByRegion().subscribe(data => {
        this.regionProfessions = data.filter(p => p.classifierType == 1 || p.classifierType == 2);
        Language.updateListLocalizedName(this.regionProfessions);
        this.regionProfessions.forEach(p => {
          if (p.classifierType == 2) {
            p.name += ' (прикладной бакалавр)';
          }
        });
        this._utils.blockStop();
      });
    }
  }

  initDicEducatedList() {
    this._enrollApplicationService.getDicEducatedList().subscribe(data => {
      this.educated = data.filter( h => h.id !== 4 && h.id !== 5);
      Language.updateListLocalizedName(this.educated);
    });
  }

  professionChanged() {
    this.application.college = 0;
    this.application.specializationid = 0;
    this.initSpecializationsGrantList();
  }

  initStudyLanguages() {
    this.studylanguages = [
      {id: 1, nameRu: 'Русский', nameKz: 'Орысша', name: ''},
      {id: 2, nameRu: 'Казахский', nameKz: 'Қазақша', name: ''},
      {id: 40, nameRu: 'Уйгурский', nameKz: 'Ұйғыр', name: ''}
    ];
    Language.updateListLocalizedName(this.studylanguages);
  }

  studyLanguageChanged() {
    this.application.professionid = 0;
    this.application.college = 0;
    this.application.specializationid = 0;
    this.initRegionProfessions();
  }

  educatedChanged() {
    this.application.professionid = 0;
    this.application.specializationid = 0;
    this.application.college = 0;
    this.initRegionProfessions();
  }

  specializationsChanged() {
    this.application.college = 0;
    this.colleges = [];
    this.getColleges();
  }

  initSpecializationsGrantList () {
    if (this.application.professionid > 0 && this.application.educatedid > 0
      && this.application.studylanguageid > 0) {
      const filter = {
        centerProfessionId: this.application.professionid,
        educatedId: this.application.educatedid,
        studylanguageId: this.application.studylanguageid,
        isUsedInGrant: true,
        status: 5,
        year: new Date().getFullYear()
      };
      this._utils.blockStart();
      if (this.application.paymentformid == 2) {
        this._enrollApplicationService.getCenterSpecializations(filter).subscribe(data => {
          this.specializations = data;
          Language.updateListLocalizedName(this.specializations);
          this._utils.blockStop();
        });
      } else {
        this._enrollApplicationService.getCenterSpecializationsByProfId(filter).subscribe(data => {
          this.specializations = data;
          Language.updateListLocalizedName(this.specializations);
          this._utils.blockStop();
        });
      }
    }
  }

  loadPaymentForms(){
    this._enrollApplicationService.getDicPaymentFormsList().subscribe(data => {
        this.paymentForms = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _enrollApplicationService.getDicPaymentFormsList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  loadDepartments() {
    this._enrollApplicationService.getDicDepartmentsList().subscribe(data => {
        this.departments = this._utils.translateListWithSort(data, 'name');
      }, err => { console.log('EnrollCabinetComponent _enrollApplicationService.getDicDepartmentsList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  paymentFormChanged(event) {
    this.application.professionid = 0;
    this.application.specializationid = 0;
    this.application.college = 0;
    this.loadGrantType(event);
    this.initRegionProfessions();
    if (this.application.paymentformid == 2) {
      this.application.department_id = 1;
    }
  }

  loadGrantType(event) {
    if (event) {
      this.application.grantType = null;
    }
    this._enrollApplicationService.getGrantTypes(this.application.paymentformid).subscribe(data => {
      this.grantTypeList = data;
      // обучение платно
      if (this.application.paymentformid === 1){
        this.application.grantType = -7;
        // обучение бесплатно
      } else if (this.application.paymentformid === 2){
        this.application.grantType = -8;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/enroll-enter/enroll-application-dialog/enroll-application-dialog.component.ts